<template>
  <div class="webHomeModular">
    <navBarNoLab :onIndex="0"></navBarNoLab>
    <div class="webContent">
      <div class="banner" v-if="bannerInfo">
        <div class="banner_bg1"></div>
        <div class="banner_bg2">
          <div class="video">
            <div class="bannerfont">
              <div class="playRow">
                <div
                  v-if="true"
                  @click="handleVideo('https://v.itheima.net/Xtxsp-1.mp4')"
                  class="playBut"
                >
                  <img src="./images/btn_play.png" width="80px" alt="" />
                  <div>课程赏析</div>
                </div>
                <!-- <div class="banPlayBut">
                  <img src="../../../../assets/btn_play_ban.png" width="27px" alt=""/>
                  查看需求文档
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="banner_bg3">
          <div class="butCont">
            <router-link target="_blank" to="/web-xtx"
              ><div class="but">体验Vue3.0项目</div></router-link
            >
          </div>
        </div>
      </div>
      <div class="banner_react" style="display: none" v-if="bannerInfo">
        <div class="banner_bg1"></div>
        <div class="banner_bg2">
          <div class="video">
            <div class="bannerfont">
              <div class="playRow"></div>
            </div>
            <router-link target="_blank" class="but" to="/web-xtx"
              >50</router-link
            >
          </div>
        </div>
      </div>
      <div
        id="scrollTg1"
        class="screen objectList"
        style="padding-top: 20px"
        v-if="objectListdata && objectListdata.length > 0"
      >
        <div class="centent">
          <div class="title" v-if="objectListdata.length > 0">
            前端 {{ objectListdata.length }}个行业真项目，快速体验
          </div>
          <div class="cont">
            <div class="objectItems">
              <div class="labCont" v-if="objectListdata.length > 12">
                <div
                  class="item"
                  :class="{ active: index === objectIndex }"
                  v-for="(item, index) in objectListdata"
                  :key="index"
                  @click="objectHandle(item, index)"
                >
                  {{ item.title }}
                </div>
              </div>
              <div class="labCont" style="justify-content: center" v-else>
                <div
                  class="item"
                  :class="{ active: index === objectIndex }"
                  v-for="(item, index) in objectListdata"
                  :key="index"
                  @click="objectHandle(item, index)"
                >
                  {{ item.title }}
                </div>
              </div>
              <div class="objCont">
                <div class="objBaseInfo" :key="objectIndex">
                  <div class="logo">
                    <img
                      v-if="objectInfoData.banner.length > 0"
                      :src="objectInfoData.banner[0].url"
                      alt=""
                    />
                  </div>
                  <div class="info">
                    <div>{{ objectInfoData.info }}</div>
                    <div class="label" v-if="objectInfoData.BotTitle">
                      <span
                        v-for="(item, index) in objectInfoData.BotTitle.split(
                          '|'
                        )"
                        :key="index"
                        >{{ item }}</span
                      >
                    </div>
                  </div>
                  <div class="button" @click="goDetails(objectInfoData)">
                    <span class="anim"></span>
                    <img src="./images/img/icon_tiyan.png" alt="" />
                    立即体验
                  </div>
                </div>
                <div class="rollBox">
                  <div
                    class="rollBar"
                    v-if="
                      objectInfoData.contListDataes &&
                      objectInfoData.contListDataes.length >= 2
                    "
                  >
                    <div
                      class="leftBar"
                      :class="{ noHandle: rollItemIndex == 0 }"
                      @click="carouselhandle('red')"
                    >
                      <i class="icon iconfont iconicon_more_sel2x"></i>
                    </div>
                    <div class="labBar">
                      <span
                        :class="{ act: index === rollItemIndex }"
                        v-for="(item, index) in objectInfoData.contListDataes"
                        :key="index"
                        @click="() => (rollItemIndex = index)"
                      ></span>
                    </div>
                    <div
                      class="rightBar"
                      :class="{
                        noHandle:
                          rollItemIndex ==
                          objectInfoData.contListDataes.length - 1,
                      }"
                      @click="carouselhandle('add')"
                    >
                      <i class="icon iconfont iconicon_more_sel2x"></i>
                    </div>
                  </div>
                  <div class="rollCont">
                    <div class="scrollCont" :style="programCroll">
                      <div
                        class="scrollImg"
                        v-for="(it, ind) in objectInfoData.contListDataes"
                        :key="ind"
                        :class="{
                          current: ind == rollItemIndex,
                          prevCurrent: ind == rollItemIndex - 1,
                          nextCurrent: ind == rollItemIndex + 1,
                          prevNode: ind < rollItemIndex - 1,
                          nextNode: ind > rollItemIndex + 1,
                        }"
                        @click="carouselhandle('add', ind)"
                      >
                        <img
                          v-if="it.ButtonImage.length > 0"
                          :src="it.ButtonImage[0].url"
                          width="300px"
                          alt=""
                        />
                        <div
                          class="objPlay"
                          v-if="it.url"
                          @click="handleVideo(it.url)"
                        >
                          <img
                            src="./images/img/icon_play2.png"
                            width="60px"
                            alt=""
                          />
                        </div>
                        <div class="rollFloatIcon">
                          <div class="iconbox">
                            <img
                              v-if="it.image"
                              :src="it.image[0].url"
                              width="30px"
                              alt=""
                            />
                          </div>
                          <div>{{ it.title }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="scrollTg1" v-else></div>
      <div id="scrollTg2" class="modelTg2">
        <div class="title">职场老手教你如何分辨「真假」项目课程</div>
        <div class="subTitle">能够分辨，才能学到真项目，才能找到好工作</div>
        <div class="contTitBox">
          <div class="titlelab">
            <div>真项目</div>
            <div>假项目</div>
          </div>
          <div class="cont">
            <div class="leftItem" :class="{ ltShow: labTop2 == true }">
              <div class="item" v-for="item in realObjData" :key="item">
                {{ item }}
              </div>
            </div>
            <div class="rightItem" :class="{ rtShow: labTop2 == true }">
              <div class="item" v-for="item in fakeObjData" :key="item">
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <div class="bgLeftImg">
          <img src="./images/img/bg_left_img.png" alt="" />
        </div>
        <div class="bgRitImg">
          <img src="./images/img/bg_rit_img.png" alt="" />
        </div>
      </div>
      <div id="scrollTg31" class="screen advantageModuleA">
        <div class="centent" :class="{ isShow: tag31 == true }">
          <div class="title">
            真实的设计稿，真实的开发环境，做你真实的开发实战
          </div>
          <div class="itemsCont">
            <div class="driedlabel">
              <div
                class="driedLabelBox"
                v-for="(item, index) in webNewDataes.firstModuleDataes"
                :key="index"
              >
                <div class="iconImg">
                  <img :src="item.iconImg[0].url" alt="" />
                </div>
                <div class="line"></div>
                <div class="descCont">
                  <div class="fontIcon">{{ `0${index + 1}` }}</div>
                  <div class="text">
                    <p>{{ item.desc[0] }}</p>
                    <p>{{ item.desc[1] }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div id="scrollTg32" class="screen advantageModuleB">
        <div class="centent" :class="{ isShow: tag32 == true }">
          <div class="title" style="margin-bottom: 60px">学员实战作品呈现</div>
          <swiper :options="swiperOptionprd">
            <swiper-slide
              v-for="(item, index) in webNewDataes.secondModuleDataes"
              :key="index"
              class="items"
            >
              <div
                class="item"
                v-for="(it, ind) in item"
                :key="ind + String(index)"
                @click="openNewUrl(it.routerUrl)"
              >
                <div class="markCont">
                  <div @mouseover="videoPlayback(`video${it.id}`)" class="but">
                    在线演示
                  </div>
                </div>
                <video
                  :ref="`video${it.id}`"
                  :poster="it.img[0].url"
                  @mouseover="videoPlayback(`video${it.id}`)"
                  @mouseout="videoStopped(`video${it.id}`)"
                  width="100%"
                  loop
                >
                  <source type="video/mp4" :src="it.videoUrl" />
                </video>
                <div>
                  <div class="tit">{{ it.title }}</div>
                  <div class="subTit">{{ it.subTit }}</div>
                </div>
                <div
                  class="desc"
                  @mouseover="videoPlayback(`video${it.id}`)"
                  @mouseout="videoStopped(`video${it.id}`)"
                >
                  {{ it.desc }}
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiperButtons">
            <div class="swiper-button-prevprd icon iconfont"></div>
            <div class="swiper-paginationprd"></div>
            <div class="swiper-button-nextprd icon iconfont"></div>
          </div>
        </div>
      </div> -->
      <div class="adv">
        <img src="./images/img/img_adv.png" width="100%" alt="" />
      </div>
      <div id="scrollTg33"></div>
      <div
        id="scrollTg331"
        style="display: none"
        class="screen advantageModuleC"
      >
        <div class="centent" :class="{ isShow: tag33 == true }">
          <div class="title">{{ webNewDataes.thirdModuleDataes.title }}</div>
          <div class="subTitle">
            {{ webNewDataes.thirdModuleDataes.subTit }}
          </div>
          <div class="items" style="margin-bottom: 0px">
            <div
              class="item"
              v-for="(item, index) in webNewDataes.thirdModuleDataes.items"
              :key="index"
            >
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
          <div class="terminalItems" style="display: none">
            <div
              class="item"
              v-for="(item, index) in webNewDataes.thirdModuleDataes
                .terminalItems"
              :key="index"
            >
              <div class="image">
                <router-link class="link" to="/">快速体验</router-link>
                <img :src="item.imgUrl" width="100%" alt="" />
              </div>
              <div class="info">
                <div class="tit">{{ item.title }}</div>
                <div>{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="scrollTg34" class="screen advantageModuleD">
        <div class="centent" :class="{ isShow: tag34 == true }">
          <div class="title">{{ webNewDataes.fourthModuleDataes.title }}</div>
          <div class="subTitle">
            {{ webNewDataes.fourthModuleDataes.subTit }}
          </div>
          <div class="contBox">
            <div class="leftCont">
              <div class="tit">
                {{ webNewDataes.fourthModuleDataes.mainLeftData.title }}
              </div>
              <div class="items">
                <div
                  class="item"
                  v-for="(item, index) in webNewDataes.fourthModuleDataes
                    .mainLeftData.items"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
            </div>
            <div class="ritCont">
              <div class="tit">
                {{ webNewDataes.fourthModuleDataes.mainRitData.title }}
              </div>
              <div class="items">
                <div
                  class="item"
                  v-for="(item, index) in webNewDataes.fourthModuleDataes
                    .mainRitData.items"
                  :key="index"
                >
                  <img
                    :src="item.iconImg"
                    width="38px"
                    v-if="item.iconImg"
                    alt=""
                  />
                  {{ item.desc }}
                </div>
              </div>
            </div>
          </div>
          <router-link class="but" target="_blank" to="/web-xtx"
            >体验Vue3.0项目</router-link
          >
        </div>
      </div>
      <div id="scrollTg35" class="screen advantageModuleE">
        <div class="centent" :class="{ isShow: tag35 == true }">
          <div class="title">{{ webNewDataes.fifthModuleDataes.title }}</div>
          <div class="subTitle">
            {{ webNewDataes.fifthModuleDataes.subTit }}
          </div>
          <div class="items">
            <img src="./images/img/img_tanhua.png" width="890px" alt="" />
            <div class="fontRule">
              <div
                class="item"
                v-for="(item, index) in webNewDataes.fifthModuleDataes.items"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <router-link class="but" target="_blank" to="/web-thjy"
            >体验RN项目</router-link
          >
        </div>
      </div>
      <div id="scrollTg36" class="screen advantageModuleF">
        <div class="centent" :class="{ isShow: tag36 == true }">
          <div class="title">{{ webNewDataes.sixthModuleDataes.title }}</div>
          <div class="subTitle">
            {{ webNewDataes.sixthModuleDataes.subTit }}
          </div>
          <div class="items">
            <div>
              <img src="./images/img/echart-ys.png" width="383" alt="" />
            </div>
            <div class="info">
              <div
                class="item"
                v-for="(item, index) in webNewDataes.sixthModuleDataes.items"
                :key="index"
              >
                {{ item }}
              </div>
              <router-link class="but" target="_blank" to="/web-lkd"
                >体验Echarts项目</router-link
              >
            </div>
            <div>
              <img src="./images/video/img_ksh.gif" width="553" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div id="scrollTg37" class="screen advantageModuleG">
        <div class="centent" :class="{ isShow: tag37 == true }">
          <div class="title">{{ webNewDataes.seventhModuleDataes.title }}</div>
          <div class="subTitle">
            {{ webNewDataes.seventhModuleDataes.subTit }}
          </div>
          <div class="TruePlan">
            <div
              class="itemCont"
              :class="{
                scrollShow: webNewDataes.seventhModuleDataes.items.length > 9,
              }"
            >
              <div
                class="list"
                v-for="(item, index) in webNewDataes.seventhModuleDataes.items"
                :key="index"
                @mouseover="() => (showDescInd = index)"
                @mouseout="() => (showDescInd = '')"
              >
                <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :content="item.desc"
                >
                  <div slot="reference">
                    <div class="tit">{{ item.title }}</div>
                    <div class="desc">{{ cutstr(item.desc, 42) }}</div>
                  </div>
                </el-popover>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="scrollTg4" class="screen system">
        <div class="centent">
          <div class="title" style="margin-bottom: 80px">
            大前端人才培养体系
          </div>
          <div class="grid" :class="{ isShow: isShow == true }">
            <img src="./images/img/img_roll.png" width="497px" alt="" />
            <div
              class="point"
              :class="`point${index}`"
              v-for="(item, index) in gridData"
              :key="index"
            >
              <div class="tit">{{ item.tit }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
      <div id="scrollTg5" class="screen goodProject">
        <div class="centent">
          <div class="title">用心打磨才是好项目</div>
          <div class="subTitle">
            传智播客的每一套项目课程都要经过<span>8次</span>品控把关，从立项到研发，再到课程转化录制，
            每一个环节至少有<span>10项</span>的验收标准，制定如此复杂的流程和严格的标准，只为学员能够学到更优质的课程
          </div>
          <img
            :class="{ isShow: goodProject == true }"
            src="./images/img/img-bot.png"
            width="100%"
            alt=""
          />
        </div>
      </div>
    </div>
    <MenuAdd ref="editMenu"></MenuAdd>
    <bottom-widge></bottom-widge>
  </div>
</template>

<script>
import navBarNoLab from './../../../components/navBarNoLab';
import bottomWidge from './../../../components/bottomWidge';
import MenuAdd from './../../../components/video';
import { JavaHome } from '../../../../gqlapi/JavaHome.js';
import { CutString } from './../../../../utils/tools';
import webNewDataes from './web.data.js';

export default {
  name: 'layout',
  components: {
    MenuAdd,
    navBarNoLab,
    bottomWidge,
  },
  data() {
    // const vm = this;
    return {
      dialogVisible: false,
      overClassName: 'show1',
      className: {},
      bannerInfo: {},
      screenWidth: 1210,
      rollItemIndex: 0,
      webNewDataes,
      realObjData: [
        '1.完整体验：商用级产品设计、技术实现',
        '2.企业级项目部署、测试与运维监控，零bug',
        '3.“周”单位依据市场需求及教学反馈，持续优化',
        '4.课程天数≥5，功能数≥9，解决方案数≥7',
        '5.项目配套文档，一应俱全！',
      ],
      fakeObjData: [
        '1.文字游戏，只能预览图片，鲜少能体验',
        '2.项目不维护、不更新，bug数＞功能数',
        '3.技术过时，系统老旧，从不更新',
        '4.课程天数<5，功能数<9，解决方案数<7',
        '5.需求文档、开发文档等，全无！',
      ],
      gridData: [
        { tit: '问题解决能力', desc: '核心讲解解决方案思路及应用场景' },
        { tit: '业务分析能力', desc: '全套产品文档，培养业务分析能力' },
        { tit: '项目沟通能力', desc: '项目实战课程由学生亲自操练' },
        { tit: '学习探索能力', desc: '引导式教学，培养学习能力' },
        {
          tit: '团队协作能力',
          desc: '版本控制、错误报告、自动化、强化团队协作能力',
        },
        { tit: '前端开发能力', desc: '亲历项目从开始到上线的全周期开发' },
      ],
      roundData: [
        '基于 art-template的模板引擎',
        '基于 Layui 模块化前端框架',
        '通用网络请求解决方案',
        '通用图片上传解决方案',
        '基于JWT的身份验证',
        '移动端登录解决方案',
        '基于 ECharts 的数据可视化解决方案',
        '基于 iframe 的无刷新解决方案',
        '基于 CORS 的跨域解决方案',
        '基于 ORM 的数据模型解决方案',
        '基于 LocalStorage 客户端存储解决方案',
        '移动端 APP 启动解决方案',
        '通用表单解决方案',
        '移动端本地存储解决方案',
        '通用弹窗解决方案',
        '基于 cookie/session 的身份验证解决方案',
        '使用 swagger 接口文档展示方案',
        '移动端本地存储解决方案',
        '通用弹窗解决方案',
        '基于 cookie/session 的身份验证解决方案',
        '使用 swagger 接口文档展示方案',
      ],
      floatPositTop: 0,
      objectListdata: null,
      swiperOptionprd: {
        slidesPerView: 1,
        spaceBetween: 33,
        autoplay: 5000,
        loop: false,
        loopFillGroupWithBlank: true,
        allowTouchMove: false,
        navigation: {
          nextEl: '.swiper-button-nextprd',
          prevEl: '.swiper-button-prevprd',
        },
        pagination: {
          el: '.swiper-paginationprd',
          clickable: true,
          // type: 'custom',
          // renderCustom: function (swiper, current, total) {
          //   let htmlCont = '';
          //   for (let i = 1; i <= total; i++) {
          //     if (current == i) {
          //       htmlCont += vm.swiperDataes[i-1].url ? `<a href="${vm.swiperDataes[i-1].url}" target="_blank"><div class="swiper-pagination-bullet swiper-pagination-active">${vm.swiperDataes[i-1].title}</div></a>` : `<div class="swiper-pagination-bullet swiper-pagination-active">${vm.swiperDataes[i-1].title}</div>`
          //     } else {
          //       htmlCont += vm.swiperDataes[i-1].url ? `<a href="${vm.swiperDataes[i-1].url}" target="_blank"><div class="swiper-pagination-bullet">${vm.swiperDataes[i-1].title}</div></a>` : htmlCont += `<div class="swiper-pagination-bullet">${vm.swiperDataes[i-1].title}</div>`
          //     }
          //   }
          //   return htmlCont
          // }
        },
      },
      objectIndex: 0,
      openTag: 0,
      overTag: 0,
      numberA: 34,
      numberB: 1100,
      numberC: 12,
      timerNum: { numberA: null, numberB: null, numberC: null },
      baseInfo: {
        baseInfoTitle1: '',
        baseInfoTitle2: '',
        baseInfoDesc1: '',
        baseInfoDesc2: '',
        pVideoUrl: '',
        videoLogoImage: '',
      },
      contTop: 2500,
      floatTag: 0,
      scrollLeft: 0,
      botTop: 0,
      pslt: 0,
      psrt: 0,
      labTop2: false,
      isShow: false,
      goodProject: false,
      tag31: false,
      tag32: false,
      tag33: false,
      tag34: false,
      tag35: false,
      tag36: false,
      tag37: false,
    };
  },
  computed: {
    objectInfoData() {
      let data = null;
      if (this.objectListdata) {
        data = this.objectListdata[this.objectIndex];
      }
      return data;
    },
    programCroll() {
      return {
        width: this.objectInfoData.contListDataes.length * 300 + 'px',
      };
    },
    floatPosit() {
      let pos = { position: 'absolute', top: '0px' };
      if (this.floatPositTop < this.contTop) {
        pos = { position: 'absolute' };
      } else if (
        this.floatPositTop >= this.contTop &&
        this.floatPositTop < this.botTop - 588
      ) {
        pos = { position: 'fixed', top: '98px' };
        if (this.screenWidth >= 1440) {
          pos = { ...pos, left: (this.screenWidth - 1440) / 2 + 'px' };
        }
        if (this.screenWidth <= 1210) {
          pos = { ...pos, left: -this.scrollLeft + 'px' };
        }
      } else {
        pos = { position: 'absolute', top: 'auto', bottom: '170px' };
      }
      return pos;
    },
  },
  created() {
    this.getWebHomeDataes();
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;
    window.addEventListener('scroll', this.scrollHandle);
  },
  methods: {
    // 初始化数据获取
    getWebHomeDataes() {
      this.$axios
        .post('/api', {
          operationName: 'JavaHome',
          variables: {
            id: 5,
          },
          query: JavaHome,
        })
        .then((res) => {
          const data = res.data.data.javaHome;
          this.objectListdata = data.objectLists.filter((it) => {
            if (it.isOpen) {
              return it;
            }
          });
        })
        .catch((res) => {
          console.log('JavaHome 请求出错：' + res);
        });
    },
    videoPlayback(videoTag) {
      if (this.$refs[videoTag]) {
        this.$refs[videoTag][0].play();
      }
    },
    videoStopped(videoTag) {
      if (this.$refs[videoTag]) {
        this.$refs[videoTag][0].pause();
      }
    },
    cutstr(str, ind) {
      return CutString(str, ind);
    },
    overHandle(className) {
      this.overClassName = className;
    },
    setPsHandle(tag) {
      if (tag == 'lt') {
        return Math.random() * 200;
      } else {
        return Math.random() * 300;
      }
    },
    openFileHandle(url) {
      if (url) {
        window.open(url, '_blank');
      } else {
        this.dialogVisible = true;
      }
    },
    // 点击跳转到项目详情
    goDetails(item) {
      if (item.url == null) {
        return false;
      }
      window.open(item.url, '_blank');
    },
    openNewUrl(url) {
      window.open(url, '_blank');
    },
    // web 项目切换
    carouselhandle(ist, ind) {
      let st = ist;
      if (ind != 'undefined' && ind < this.rollItemIndex) {
        st = 'red';
      }
      if (ind && ind == this.rollItemIndex) {
        return false;
      }

      const num = this.objectInfoData.contListDataes.length - 1;
      if (st == 'add') {
        this.rollItemIndex =
          this.rollItemIndex < num
            ? this.rollItemIndex + 1
            : this.rollItemIndex;
      } else {
        this.rollItemIndex =
          this.rollItemIndex == 0 ? 0 : this.rollItemIndex - 1;
      }
    },
    objectHandle(item, index) {
      this.rollItemIndex = item.contListDataes.length >= 3 ? 1 : 0;
      this.objectIndex = index;
    },
    // 滚动浮窗
    scrollHandle() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let scrollLeft =
        window.pageXOffset ||
        document.documentElement.scrollLeft ||
        document.body.scrollLeft;
      this.floatPositTop = scrollTop;
      let aimsId = document.querySelector('#scrollTg1');
      let aimsId1 = document.querySelector('#scrollTg2');
      let aimsId21 = document.querySelector('#scrollTg31');
      // let aimsId22 = document.querySelector('#scrollTg32');
      let aimsId23 = document.querySelector('#scrollTg33');
      let aimsId24 = document.querySelector('#scrollTg34');
      let aimsId25 = document.querySelector('#scrollTg35');
      let aimsId26 = document.querySelector('#scrollTg36');
      let aimsId27 = document.querySelector('#scrollTg37');
      let aimsId3 = document.querySelector('#scrollTg4');
      let aimsId4 = document.querySelector('#scrollTg5');
      this.scrollLeft = scrollLeft;
      const baseTag = -650;
      if (scrollTop >= baseTag && scrollTop <= aimsId.offsetTop + baseTag) {
        this.floatTag = 0;
      } else if (
        scrollTop >= aimsId1.offsetTop + baseTag &&
        scrollTop < aimsId21.offsetTop + baseTag
      ) {
        this.labTop2 = true;
      } else if (
        scrollTop >= aimsId21.offsetTop + baseTag &&
        scrollTop < aimsId23.offsetTop + baseTag
      ) {
        this.tag31 = true;
      }
      // else if (
      //   scrollTop >= aimsId22.offsetTop + baseTag &&
      //   scrollTop < aimsId23.offsetTop + baseTag
      // ) {
      //   this.tag32 = true;
      // }
      else if (
        scrollTop >= aimsId23.offsetTop + baseTag &&
        scrollTop < aimsId24.offsetTop + baseTag
      ) {
        this.tag33 = true;
      } else if (
        scrollTop >= aimsId24.offsetTop + baseTag &&
        scrollTop < aimsId25.offsetTop + baseTag
      ) {
        this.tag34 = true;
      } else if (
        scrollTop >= aimsId25.offsetTop + baseTag &&
        scrollTop < aimsId26.offsetTop + baseTag
      ) {
        this.tag35 = true;
      } else if (
        scrollTop >= aimsId26.offsetTop + baseTag &&
        scrollTop < aimsId27.offsetTop + baseTag
      ) {
        this.tag36 = true;
      } else if (
        scrollTop >= aimsId27.offsetTop + baseTag &&
        scrollTop < aimsId3.offsetTop + baseTag
      ) {
        this.tag37 = true;
      } else if (
        scrollTop >= aimsId3.offsetTop + baseTag &&
        scrollTop < aimsId4.offsetTop + baseTag
      ) {
        this.isShow = true;
      } else if (scrollTop >= aimsId4.offsetTop + baseTag) {
        this.goodProject = true;
      }
    },
    handleVideo(url, e) {
      // 由于切换图层原因，传参url为之后一个 所以不可用 将url放到了切换事件中进行更换
      this.baseInfo.pVideoUrl = url;
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenu.dialogFormV(this.baseInfo);
    },
  },
};
</script>
<style src="./style.scss" rel="stylesheet/scss" lang="scss" scoped></style>
<style lang="scss">
.webHomeModular {
  .swiper-container {
    padding: 0 !important;
  }
  .swiper-pagination-clickable .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    margin: 0 5px;
    background: #848586;
  }
  .swiper-pagination-bullet-active {
    background: #0daffe !important;
  }
  .swiperButtons {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 80px;
  }
  .swiper-button-prevprd,
  .swiper-button-nextprd {
    transform: rotate(360deg);
    cursor: pointer;
    width: 21px;
    height: 21px;
    border-radius: 100%;
    margin: 0 5px;
    background: #ffffff;
    box-shadow: 0 0 8px 0 rgba(22, 37, 73, 0.11);
    color: #0eaffe;
    font-size: 11px;
    line-height: 21px;
    text-align: center;
    &::before {
      content: '\e6e2';
    }
  }
  .swiper-button-prevprd {
    transform: rotate(180deg);
    &::before {
      content: '\e6e2';
    }
  }
  .swiper-button-disabled {
    &::before {
      color: #e0ebf7;
    }
  }
}
</style>
